import { useUser } from '@folklore/auth';
import { useTracking } from '@folklore/tracking';
import classNames from 'classnames';
import isArray from 'lodash-es/isArray';
import uniq from 'lodash-es/uniq';
import { ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useCurrentDocument } from '../../hooks/useDocument';

import { usePopupsContext } from '../../contexts/PopupsContext';
import BasicButton from '../buttons/BasicButton';
// import SsoButton from '../buttons/SsoButton';
import SubscriptionForm from '../forms/SubscriptionForm';
// import LineSpacer from '../partials/LineSpacer';
import PromotionCard from './PromotionCard';

import styles from '../../styles/cards/promotion-subscription-card.module.css';

import micromagFree from '../../assets/img/promotions/micromag_free.svg';

// @TODO: Swtch input type
interface PromotionSubscriptionCardProps extends Partial<SubscriptionPromotion> {
    source?: string | null;
    buttonLabel?: ReactNode | null;
    theme?: string | null;
    onComplete?: ((user: User) => void) | null;
    className?: string | null;
    innerClassName?: string | null;
    titleClassName?: string | null;
    descriptionClassName?: string | null;
    imageClassName?: string | null;
    pictureClassName?: string | null;
    callToActionClassName?: string | null;
}
function PromotionSubscriptionCard({
    source = null,
    handle = null,
    title = 'Abonnez-vous à<br/>l’infolettre URBANIA',
    description = 'Chaque lundi et mercredi : nos contenus qui soulèvent les passions.',
    titleLogin = null,
    descriptionLogin = null,
    buttonLabel = null,
    subscription = null,
    subscriptions = null,
    theme = 'urbania',
    className = null,
    innerClassName = null,
    titleClassName = null,
    descriptionClassName = null,
    imageClassName = null,
    pictureClassName = null,
    callToActionClassName = null,
    onComplete = null,
    ...props
}: PromotionSubscriptionCardProps) {
    const user = useUser();
    const currentDocument = useCurrentDocument();
    const { type = null, image, images: { cover = null } = {} } = currentDocument || {};
    const finalImage = cover || image;
    const { addMessage } = usePopupsContext();
    const tracking = useTracking();
    const [login, setLogin] = useState(false);
    const onClickLogin = () => {
        setLogin(!login);
    };
    const onSubscribeComplete = ({ user: newUser }, method) => {
        tracking.trackEvent('Auth', 'login', method);
        if (login) {
            addMessage('hi', {
                user: newUser,
                isNew: false,
            });
        }
        if (onComplete !== null) {
            onComplete(newUser);
        }
    };
    const finalSubscriptions = uniq(
        [subscription, ...(isArray(subscriptions) ? subscriptions : [subscriptions])].filter(
            (it) => it !== null,
        ),
    );
    const isMicromag = type === 'micromag';
    const [mainSubscription = 'urbania'] = finalSubscriptions;
    const finalSource = source || handle || `promotion-${mainSubscription}`;
    return (
        <PromotionCard
            callToAction={
                <>
                    <SubscriptionForm
                        // withPopout
                        // withFull
                        subscribeButtonLabel={
                            login ? (
                                <FormattedMessage
                                    defaultMessage="Connexion"
                                    description="Button label"
                                />
                            ) : (
                                buttonLabel
                            )
                        }
                        alwaysHorizontal={theme === 'micromag'}
                        withoutMessages={login}
                        subscription={finalSubscriptions.length <= 1 ? mainSubscription : null}
                        subscriptions={finalSubscriptions.length > 1 ? finalSubscriptions : null}
                        source={finalSource}
                        onComplete={onSubscribeComplete}
                        className={styles.form}
                        withoutEditContact
                    />

                    {user === null ? (
                        <div className={styles.login}>
                            {!login ? (
                                <FormattedMessage
                                    defaultMessage="Vous êtes déjà abonné·e? {link}"
                                    description="Link label"
                                    values={{
                                        link: (
                                            <BasicButton
                                                className={styles.link}
                                                onClick={onClickLogin}
                                            >
                                                <FormattedMessage
                                                    defaultMessage="Connectez-vous"
                                                    description="Button label"
                                                />
                                            </BasicButton>
                                        ),
                                    }}
                                />
                            ) : (
                                <FormattedMessage
                                    defaultMessage="Vous n’êtes pas abonné·e? {link}"
                                    description="Link label"
                                    values={{
                                        link: (
                                            <BasicButton
                                                className={styles.link}
                                                onClick={onClickLogin}
                                            >
                                                <FormattedMessage
                                                    defaultMessage="Abonnez-vous"
                                                    description="Button label"
                                                />
                                            </BasicButton>
                                        ),
                                    }}
                                />
                            )}
                        </div>
                    ) : null}
                </>
            }
            className={classNames([
                styles.container,
                {
                    [styles.isMicromag]: isMicromag,
                },
                className,
            ])}
            innerClassName={classNames([styles.inner, innerClassName])}
            titleClassName={classNames([styles.title, titleClassName])}
            descriptionClassName={classNames([styles.description, descriptionClassName])}
            imageClassName={classNames([styles.image, imageClassName])}
            pictureClassName={classNames([styles.picture, pictureClassName])}
            contentClassName={styles.content}
            callToActionClassName={classNames([styles.callToAction, callToActionClassName])}
            theme={theme}
            title={login ? titleLogin || title : title}
            description={login ? descriptionLogin || description : description}
            image={finalImage}
            {...props}
        >
            {/* {theme === 'full' && type !== null ? (
                <DocumentTypeIcon type={type} className={styles.typeIcon} />
             ) : null} */}
            {theme === 'full' && type !== null ? (
                <img src={micromagFree} className={styles.freeIcon} />
            ) : null}
        </PromotionCard>
    );
}
export default PromotionSubscriptionCard;
